
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-2271.51 -1131.364 1038.089 1038.078","width":"1038.089","height":"1038.078","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M-1752.465-1131.364c286.67 0 519.045 232.377 519.045 519.051 0 286.65-232.374 519.027-519.045 519.027-286.671 0-519.045-232.377-519.045-519.051.025-286.65 232.374-519.027 519.045-519.027","fill":"#1798b5"}}),_c('path',{attrs:{"d":"M-1655.675-595.214a10.861 10.861 0 00-9.828-6.23h-51.075l39.845-149.401a10.875 10.875 0 00-5.535-12.47 10.856 10.856 0 00-13.36 2.75l-152.204 184.823a10.863 10.863 0 00-1.434 11.546 10.861 10.861 0 009.828 6.23h51.076l-39.846 149.4a10.875 10.875 0 005.535 12.471 10.802 10.802 0 004.968 1.207c3.175 0 6.274-1.381 8.394-3.957l152.204-184.823a10.87 10.87 0 001.432-11.546zM-1794.31-451.26l30.604-114.774c.87-3.261.174-6.74-1.88-9.425a10.877 10.877 0 00-8.622-4.25h-42.194l105.782-128.45-30.604 114.773a10.886 10.886 0 001.88 9.425 10.878 10.878 0 008.622 4.252h42.194l-105.782 128.45zM-1687.235-938.482h-130.46c-6.001 0-10.872 4.87-10.872 10.871v43.487c0 6.001 4.87 10.872 10.871 10.872h130.461c6 0 10.871-4.87 10.871-10.872v-43.487c0-6-4.87-10.871-10.871-10.871zm-10.871 43.487h-108.717v-21.743h108.717v21.743z","fill":"#fff"}}),_c('path',{attrs:{"d":"M-1631.039-894.995h-242.853c-22.972 0-41.65 18.689-41.65 41.651v525.524c0 22.961 18.7 41.65 41.65 41.65h242.853c22.96 0 41.65-18.689 41.65-41.65v-525.524c0-22.962-18.69-41.651-41.65-41.651zm19.895 567.175c0 10.981-8.925 19.907-19.906 19.907h-242.852c-10.981 0-19.907-8.926-19.907-19.907v-525.524c0-10.98 8.936-19.907 19.907-19.907h242.852c10.98 0 19.906 8.926 19.906 19.907v525.524z","fill":"#fff"}})])
          )
        }
      }
    